import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { DynamicList } from "../components/DynamicList"
import { VoiceField } from "@/components/planning/client-only/VoiceField"
import { GuideMeCta } from "@/components/planning/client-only/GuideMeCta"

function defaultRows(saved) {
  if (saved && saved.length > 0) return saved
  return Array.from({ length: 3 }, () => ({ title: "", status: "on_track" }))
}

export function QuarterRocks({ data }) {
  const [rows, setRows] = useState(() => defaultRows(data.quarter.rocks))
  const [processing, setProcessing] = useState(false)

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "quarter_rocks", quarter_rocks: rows, advance: "1" },
      { preserveScroll: true, onFinish: () => setProcessing(false) },
    )
  }

  return (
    <StepShell
      title="This quarter's rocks"
      subtitle="3–5 big things you're going to accomplish in the next 90 days. If only these got done, this quarter would be a win."
      onNext={submit}
      processing={processing}
    >
      <GuideMeCta
        section="quarter_rocks"
        onInsert={(bullets) =>
          setRows(
            bullets
              .slice(0, 5)
              .map((title) => ({ title, status: "on_track" })),
          )
        }
        title="Struggling to name the right rocks?"
        subtitle="Talk it through with an AI coach — it'll press you for specifics and hand back 3–5 sharp rocks."
      />
      <DynamicList
        items={rows}
        onChange={setRows}
        min={3}
        max={5}
        newItem={() => ({ title: "", status: "on_track" })}
        addLabel="Add another rock"
        render={(item, update) => (
          <VoiceField
            value={item.title || ""}
            onChange={(v) => update("title", v)}
            placeholder="e.g., Launch the new service tier with 5 paying customers"
            rows={2}
            ariaLabel="Quarter rock"
          />
        )}
      />
    </StepShell>
  )
}
